import React from 'react';

/**
 * GradientProgressBar component
 * Displays a progress bar with a solid gold fill and value label
 * @param {number} progress - Progress percentage (0-100)
 * @param {number} value - The actual value to display
 * @param {boolean} compact - Whether to show compact version without value
 */
const GradientProgressBar = ({ progress, value, compact = false }) => {
  // Ensure progress is between 0 and 100
  const clampedProgress = Math.min(100, Math.max(0, progress || 0));

  if (compact) {
    return (
      <div className="relative w-full h-2 bg-surface-3">
        <div
          className="absolute top-0 left-0 h-full"
          style={{
            width: `${clampedProgress}%`,
            background: 'var(--accent)'
          }}
        />
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3">
      <div className="relative w-24 h-3 bg-surface-3">
        <div
          className="absolute top-0 left-0 h-full"
          style={{
            width: `${clampedProgress}%`,
            background: 'var(--accent)'
          }}
        />
      </div>
      <span className="text-sm font-bold text-text-secondary min-w-[50px] text-right" style={{ fontFamily: 'sans-serif' }}>
        {value ? Math.round(value).toLocaleString() : '0'}
      </span>
    </div>
  );
};

export default GradientProgressBar;
